var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaintainHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.403,
    height: 119.404,
    viewBox: "0 0 145.403 119.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56407",
    "data-name": "Group 56407",
    transform: "translate(-227.297 -40.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56442",
    "data-name": "Group 56442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87523",
    "data-name": "Path 87523",
    d: "M43.04,43.851a36.436,36.436,0,0,1-11.993-3.115,25.772,25.772,0,0,1-3.037,3.541A7.788,7.788,0,0,0,35.772,51.8a7.964,7.964,0,0,1,6.1,2.643l15.015,17.2a2.855,2.855,0,0,0,2.077.927,2.762,2.762,0,0,0,2.77-2.752V58.362A28.2,28.2,0,0,1,43.04,43.851Z",
    transform: "translate(266.832 86.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87524",
    "data-name": "Path 87524",
    d: "M45.959,14A25.959,25.959,0,1,0,71.918,39.959,25.959,25.959,0,0,0,45.959,14Zm12.46,17.133L42.844,51.9a2.6,2.6,0,0,1-1.892,1.038h-.184a2.6,2.6,0,0,1-1.835-.76L33.74,46.985a2.6,2.6,0,1,1,3.671-3.671l3.076,3.076L54.266,28.018a2.6,2.6,0,0,1,4.153,3.115Z",
    transform: "translate(254.048 44.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87525",
    "data-name": "Path 87525",
    d: "M138.795,50.228a31.1,31.1,0,0,1-1.321,4.436,2.627,2.627,0,0,1-3.375,1.477,2.6,2.6,0,0,1-1.477-3.362,25.925,25.925,0,0,0-16.2-34.089,31.324,31.324,0,0,1,2.157,3.863A2.6,2.6,0,0,1,117.306,26a2.56,2.56,0,0,1-1.082.239,2.6,2.6,0,0,1-2.36-1.511A26.406,26.406,0,0,0,84.079,10.447,24.773,24.773,0,0,0,76.1,13.8a2.6,2.6,0,1,1-2.835-4.351c.4-.26.818-.472,1.225-.711a17.8,17.8,0,0,0-17.112.986,20.847,20.847,0,0,1,3.2,3.585,2.6,2.6,0,1,1-4.258,2.97A15.783,15.783,0,0,0,43.549,9.593a15.6,15.6,0,0,0-12.258,6.061,20.507,20.507,0,0,1,2.99,1.132,2.6,2.6,0,0,1,1.22,3.45,2.648,2.648,0,0,1-3.46,1.228A15.575,15.575,0,0,0,10.3,31.686a20.653,20.653,0,0,1,4.322-1.127,2.6,2.6,0,1,1,.732,5.142,15.575,15.575,0,0,0-4.434,29.5,2.6,2.6,0,1,1-2.232,4.688,20.766,20.766,0,0,1-2.972-1.757A20.788,20.788,0,0,0,25.378,82.277h.161a26.3,26.3,0,0,1-.106-4.314,2.6,2.6,0,0,1,5.192.34A20.744,20.744,0,0,0,68,92.06c-.919-.592-1.817-1.217-2.669-1.887a2.6,2.6,0,0,1,3.193-4.091,31.1,31.1,0,0,0,46.511-9.776,20.767,20.767,0,0,1-3.138-6.259,2.6,2.6,0,0,1,4.976-1.48,15.575,15.575,0,1,0,21.917-18.329ZM74.7,82.277a31.15,31.15,0,1,1,31.151-31.15A31.15,31.15,0,0,1,74.7,82.277Z",
    transform: "translate(225.307 33.027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87526",
    "data-name": "Path 87526",
    d: "M57.905,63.2c13.6,0,24.661-8.732,24.661-19.469a15.375,15.375,0,0,0-.662-4.413,20.586,20.586,0,0,1-17.564-4.1A36.571,36.571,0,0,1,36.1,52.694a24.5,24.5,0,0,0,15.835,9.911A28.9,28.9,0,0,0,57.905,63.2Z",
    transform: "translate(279.741 78.057)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintainHealth);
export default __webpack_public_path__ + "static/media/maintainHealth.aacc35c6ca7da4731c022b6643f46ae2.svg";
export { ForwardRef as ReactComponent };